<template>
    <div class="price-group-tabs">
      <div class="price-group-tabs--container">
        <div :class="'price-group-tabs--tab '+getClass(null)" @click="onPriceGroupClick(null)">
          Show All
        </div>
        <div v-for="priceGroup in priceGroups"
             :class="'price-group-tabs--tab '+getClass(priceGroup.id)"
             @click="onPriceGroupClick(priceGroup.id)">
          {{ priceGroup.title }}
        </div>
      </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "product-finish-groups",
        computed: {
            ...mapGetters(['priceGroups', 'autoScroll', 'scrollSpeed']),
        },
        methods: {
            getClass(priceGroupId) {
                if (this.currentPriceGroup === priceGroupId) {
                    return 'active'
                }
                return ''
            },
            onPriceGroupClick(e) {
                this.$emit('change', e)
            }
        },
        props: {
            currentPriceGroup: {
            }
        }
    }
</script>

<style lang="scss" scoped>
  .price-group-tabs {
    display: block;
    margin: auto;
    width: calc(100% - 320px);
    padding: 10px;

    @media screen and (max-width: 800px){
      width: 100%;
    }
    &--container {
      display: flex;
      justify-content: space-between;
      padding: 15px;
    }
    &--tab {
      font-family: "Dia Bold", sans-serif;
      font-size: 0.85rem;
      text-transform: uppercase;
      padding: 4px;
      cursor: pointer;

      color: #aaaaaa;
      &.active {
        color: #1b6f9f;
      }
    }
  }
</style>